module.exports = __webpack_public_path__ + "img/flag_gb-sct.24b10db.svg";